const REGISTER_INFORMATION_EDITABLE_STATUSES = [
  'active',
  'ativo',
  'affiliation',
  'afiliação',
  'in affiliation',
  'em afiliação'
]

const isRegisterInformationEditableStatus = status => {
  if (!status) return false
  return REGISTER_INFORMATION_EDITABLE_STATUSES.includes(status.toLowerCase())
}

export {
  REGISTER_INFORMATION_EDITABLE_STATUSES,
  isRegisterInformationEditableStatus
}
